import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, interval, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

/**
 * @class VersionCheckService
 * This service checks the version.json file every 60 seconds in order to detect that a new frontend version was deployed.
 * "version.json" is generated during the build process.
 * If a changed revision is detected, the frontend notifies the user to reload the application <-- to be defined
 */
@Injectable({ providedIn: 'root' })
export class VersionCheckService {
    private currentRev = '';
    public readonly checkInterval = 0; // 30000;    //interval to check the version file in ms, 0 = checks disabled

    constructor(private http: HttpClient) {}

    public initVersionCheck(): void {
        if (this.checkInterval > 0) {
            console.log('VersionCheckService: checking frontend version every ' + this.checkInterval + ' ms');
            interval(this.checkInterval)
                .pipe(
                    switchMap(() =>
                        this.http
                            .get<{ rev: string; time: number }>('/assets/version.json?cb=' + new Date().getTime()) // cb=timestamp for cache busting
                            .pipe(
                                catchError((err) => {
                                    console.warn('VersionCheckService: Unable to fetch version file', err);
                                    return of(null);
                                }),
                            ),
                    ),
                )
                .subscribe((version) => {
                    if (version && this.currentRev && this.currentRev !== version.rev) {
                        // TODO: implement proper frontend reload handling here...
                        console.log(
                            'VersionCheckService: NEW Frontend version deployed. old_rev="' +
                                this.currentRev +
                                '", new_rev="' +
                                version.rev +
                                '"',
                        );
                    }
                    if (version && !this.currentRev) {
                        this.currentRev = version.rev;
                    }
                });
        }
    }
}
